import { Link } from 'gatsby'
import React, { ReactNode } from 'react'
import BrandLogo from '../components/brand-logo'
import Footer from '../components/footer'
import BannerImage from '../components/banner-image'
import Heading from '../components/heading'
import NavBar from '../components/nav-bar'
import * as styles from '../styles/layouts/content-page.module.scss'
import SmallTitle from '../components/small-title'
import { apiPlugin, storyblokInit } from 'gatsby-source-storyblok'

export interface ContentPageLayoutProps {
    title?: string
    label?: string
    children?: ReactNode
    headerImage?: string
    headerImageSecondary?: string
    headerMode?: 'full' | 'half'
}

storyblokInit({
    accessToken: process.env.GATSBY_STORYBLOK_ACCESS_TOKEN,
    use: [apiPlugin],
    apiOptions: { region: 'eu' },
})

const ContentPageLayout = (props: ContentPageLayoutProps) => {
    const {
        title, label, children, headerImage, headerImageSecondary, headerMode = 'full',
    } = props

    return (
        <div className={styles.container}>
            <NavBar />
            {headerImage
                ? <header className={styles.header}>
                    <BannerImage
                        className={styles.bgImage}
                        heightMode={headerMode}
                        {...(headerImageSecondary
                            ? { imageMode: 'double', imageSrc: headerImage, imageSrcSecondary: headerImageSecondary }
                            : { imageMode: 'single', imageSrc: headerImage }
                        )}
                        imageLoadingMode="eager"
                        pixelate={true}
                    />
                    <div className={styles.titleContainer}>
                        {label && <SmallTitle className={styles.label}>{label}:</SmallTitle>}
                        <Heading as="h1">{title}</Heading>
                    </div>
                </header>
                : <header className={styles.blankHeader}>
                    {title &&
                        <div className={styles.titleContainer}>
                            <Heading className={styles.blankHeaderTitle} as="h1">
                                {title}
                            </Heading>
                        </div>
                    }
                </header>
            }
            <main>
                {children}
            </main>
            <footer className={styles.footerContainer}>
                <div>
                    <Link to={'/'} className={styles.footerBrandLogo} aria-label="Home">
                        <BrandLogo colorVariant="dark" logoVersion="contracted" animated animateOnHover />
                    </Link>
                </div>
                <Footer />
            </footer>
        </div>
    )
}

export default ContentPageLayout
